import { Embroidery, I18NText } from 'src/types'

export const genEmbroideryCells = (embroidery: Embroidery, t: I18NText): { head: string; label: string; value?: string; color?: string }[] =>
  [
    {
      head: t.TYPE_FACE,
      label: embroidery.typeFace.label,
      value: embroidery.typeFace.value,
      color: embroidery.typeFace.color
    },
    {
      head: t.POSITION,
      label: embroidery.position.label,
      value: embroidery.position.value,
      color: embroidery.position.color
    },
    {
      head: t.MAIN_COLOR,
      label: embroidery.color.label,
      value: embroidery.color.value,
      color: embroidery.color.color
    },
    embroidery.typeFace.value === 'arriba' && {
      head: t.POINT_COLOR,
      label: embroidery?.pointColor?.label,
      value: embroidery?.pointColor?.value,
      color: embroidery?.pointColor?.color
    },
    {
      head: t.SHADOW_COLOR,
      label: embroidery.shadowColor.label,
      value: embroidery.shadowColor.value,
      color: embroidery.shadowColor.color
    },
    {
      head: t.EDGE_COLOR,
      label: embroidery.edgeColor.label,
      value: embroidery.edgeColor.value,
      color: embroidery.edgeColor.color
    },
    { head: t.EMBROIDERY_CONTENTS, label: embroidery.content }
  ].filter(Boolean)
